import { z } from 'zod';

export const REFERRAL_CODE_PATTERN = /^[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{8}$/;

export const referralCodeSchema = z.string().length(8).regex(REFERRAL_CODE_PATTERN);

export const captureRefCodeSchema = z.object({
  code: referralCodeSchema,
  signupIp: z.string().optional(),
});
export type CaptureRefCodeInput = z.infer<typeof captureRefCodeSchema>;

export const applyReferralCreditSchema = z.object({
  userId: z.string().cuid(),
  baseCommissionAmount: z.number().nonnegative(),
  currency: z.enum(['EUR', 'USD']),
  otherDiscountAmount: z.number().nonnegative().optional(),
});
export type ApplyReferralCreditInput = z.infer<typeof applyReferralCreditSchema>;
